import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUserAdd: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="user-add, people, person, member"><path d="M12 20.25H4.75V19.5C4.75 15.4959 7.99594 12.25 12 12.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="7.75" r="4.5" stroke="currentColor" strokeWidth="1.5"/><path d="M18 13.75V20.25M21.25 17H14.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconUserAdd;
